module.exports = __webpack_public_path__ + "static/media/videotutorial.ea126e32.png";